import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-194763cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-list" }, null, -1))
const _hoisted_2 = { class: "p-ml-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_4 = { class: "p-ml-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-upload" }, null, -1))
const _hoisted_6 = { class: "p-ml-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-th-large" }, null, -1))
const _hoisted_8 = { class: "p-ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_CreateProduct = _resolveComponent("CreateProduct")!
  const _component_ProductCSV = _resolveComponent("ProductCSV")!
  const _component_BarcodePrinter = _resolveComponent("BarcodePrinter")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createBlock(_component_TabView, {
    "active-index": _ctx.active,
    "onUpdate:activeIndex": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      _ctx.saveActive
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("product.all")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ProductList, { categories: _ctx.categories }, null, 8, ["categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("product.new")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_CreateProduct, {
            categories: [..._ctx.categories]
          }, null, 8, ["categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("product.importCsv")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ProductCSV, { categories: _ctx.categories }, null, 8, ["categories"])
        ]),
        _: 1
      }),
      _createVNode(_component_TabPanel, null, {
        header: _withCtx(() => [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("product.barcodePrinter")), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_BarcodePrinter)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["active-index", "onUpdate:activeIndex"]))
}